<template>
  <BaseModal class="edit-description-modal" :title="`${offerVersion} ${$t('description')}`">
    <div class="editorx_body">
      <div id="description-editor" />
    </div>
    <div class="edit-description-modal__buttons spacex-16">
      <Button color="neutral" @click="closeModal">
        {{ $t('Cancel') }}
      </Button>
      <Button :loading="saving" @click="save">
        {{ $t('Save') }}
      </Button>
    </div>
  </BaseModal>
</template>

<script>
  import BaseModal from '@/components/ui/BaseModal';
  import Button from '@/components/ui/Button';
  import { mapActions, mapState } from 'vuex';
  import EditorJS from '@editorjs/editorjs';
  import Header from '@editorjs/header';
  import Paragraph from '@editorjs/paragraph';
  import List from '@editorjs/list';

  export default {
    name: 'EditDescriptionModal',
    components: {
      BaseModal,
      Button,
    },
    data() {
      return {
        editor: null,
        saving: false,
      };
    },
    mounted() {
      this.initEditor();
    },
    computed: {
      ...mapState('modal', ['context']),
      offerVersion() {
        return `V.${this.context.offer.name}`;
      },
      descriptionBlocks() {
        return this.context.offer.description;
      },
    },
    methods: {
      ...mapActions('modal', ['closeModal']),
      ...mapActions('incomingTender', ['editVersionDescription']),
      initEditor() {
        this.editor = new EditorJS({
          holder: 'description-editor',
          autofocus: true,
          readOnly: this.context.readOnly,
          data: this.context.offer.description,
          tools: {
            header: {
              class: Header,
            },
            paragraph: {
              class: Paragraph,
            },
            list: {
              class: List,
            },
          },
        });
      },
      async save() {
        this.saving = true;
        try {
          let editorData = await this.editor.save();
          await this.editVersionDescription({
            versionId: this.context.offer.id,
            description: editorData,
          });
        } catch (error) {
          console.error('Saving failed: ', error);
        }
        this.closeModal();
        this.saving = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .edit-description-modal {
    &__buttons {
      display: flex;
      justify-content: flex-end;
    }
  }
</style>
